module.exports = __webpack_public_path__ + "static/media/iphone.5e64293b.png";